import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CreateAccountComponent } from './create-account.component';
import { CampaignComponent } from './campaign.component';
import { GalleryComponent } from './gallery.component';
import { TermsAndConditionsComponent } from './termsandconditions.component';

const routes: Routes = [
    { path: 'createaccount', component: CreateAccountComponent },
    { path: 'termsandconditions', component: TermsAndConditionsComponent },
    { path: 'gallery', component: GalleryComponent },
    { path: 'campaign/:id', component: CampaignComponent },
];

@NgModule({
    imports: [RouterModule.forRoot(routes, {})],
    exports: [RouterModule]
})
export class AnonymousRoutingModule { }
